export default __webpack_public_path__ + "static/media/reviewer-3.21d99f5c.png";